import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';

import { Button, FieldRow, FormFooter, Title } from '@xsolla/ui-core';
import { ModalAlert } from '@xsolla/ui-modal';

import { CheckCircle } from '../../../assets';
import { TryModalProps } from './types';

const TryModal = ({ onClose, onSuccess }: TryModalProps): JSX.Element => {
  const intl = useIntl();

  const modalFooter = useMemo(() => {
    return (
      <FormFooter>
        <FieldRow justify="space-between" stretched>
          <Button look="tertiary" palette="muted" data-test-id="try-modal-later" onClick={onClose}>
            {intl.formatMessage({ id: 'try-login.modal.button.later' })}
          </Button>
          <Button onClick={onSuccess} data-test-id="try-modal-now">
            {intl.formatMessage({ id: 'try-login.modal.button.now' })}
          </Button>
        </FieldRow>
      </FormFooter>
    );
  }, [onClose, onSuccess]);

  return (
    <ModalAlert footer={modalFooter}>
      <React.Fragment key=".0">
        <CheckCircle />
        <Title center indent="sm">
          {intl.formatMessage({ id: 'try-login.modal.title' })}
        </Title>
        <p>{intl.formatMessage({ id: 'try-login.modal.text' })}</p>
      </React.Fragment>
    </ModalAlert>
  );
};

export default TryModal;
